<template>
  <router-view/>
  <error-notification />
</template>

<script>
import ErrorNotification from './components/notifications/ErrorNotification.vue'
export default {
  components: {ErrorNotification}
}
</script>

<style>
  @import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,300;0,400;0,500;0,700;0,900;1,300;1,500;1,700;1,900&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@200;300;400;500;600;700&display=swap');
</style>
<style>
  html, body {
    width: 100% !important;
    height: 100% !important;
    margin: 0px;
    padding: 0px;
    font-family: 'Roboto', sans-serif;
  }
  #app {
    display: block;
    width: 100% !important;
    height: 100% !important;
    margin: 0px;
    padding: 0px;
    box-sizing: border-box;
    font-family: 'Roboto', sans-serif;
  }
</style>
